import sgpHero from 'assets/images/sgp/10x25/sgp-general-hero.webp';
import altContentImage from 'assets/images/sgp/10x15/alt-content-image.webp';
import efficiency from 'assets/images/sgp/10x25/efficiency.webp';
import budget from 'assets/images/sgp/10x25/budget.webp';
import inventory from 'assets/images/sgp/10x25/inventory.webp';
import storageUnit10x25 from 'assets/images/sgp/10x25/10x25-storage.webp';
import business from 'assets/images/sgp/10x25/business.webp';
import houseMove from 'assets/images/sgp/10x25/house-move.webp';
import homeReno from 'assets/images/sgp/10x25/home-reno.webp';
import organize from 'assets/images/sgp/10x25/organize.webp';
import packing from 'assets/images/sgp/10x25/packing.webp';
import calendar from 'assets/images/sgp/10x25/calendar.webp';
import amenities from 'assets/images/sgp/10x25/amenities.webp';
import location from 'assets/images/sgp/10x25/location.webp';
import storageCar from 'assets/images/sgp/10x25/storage-car.webp';
import largestUnitSize from 'assets/images/sgp/10x25/largest-unit-size.webp';
import measured from 'assets/images/sgp/10x25/measured.webp';
import storageUnitSize from 'assets/images/sgp/10x25/storage-unit-size.webp';
import twoColumnTableImage from 'assets/images/sgp/twoColumnTable.svg';

import { pageTypes } from 'config/pageTypes';

const twoColumnTable = {
	image: twoColumnTableImage,
	title: 'Understanding Your Space: How Big is a 10x25 Storage Unit?',
	description:
		'A 10x25 storage unit provides 250 square feet of storage space with 8-foot ceilings (some facilities offer higher ceilings). To put this in perspective:',
	type: 'sizeChart',
	slug: 'size-chart-section-10x25',
	pageType: pageTypes.SGP,
	tableType: 'specialType',
	headers: [
		{
			label: 'Size',
			key: 'comparison',
		},
		{
			label: 'Square Footage',
			key: 'storageUnit',
		},
	],
	rows: [
		{
			comparison: '10x25 Storage Unit',
			storageUnit: '250 sq ft',
		},
		{
			comparison: 'One-car garage',
			storageUnit: '200–240 sq ft',
		},
		{
			comparison: 'Standard bedroom',
			storageUnit: '120–150 sq ft',
		},
		{
			comparison: 'Large living room',
			storageUnit: '250–300 sq ft',
		},
		{
			comparison: 'Studio apartment',
			storageUnit: '300–400 sq ft',
		},
	],
};

const videoImageSection = {
	content: {
		pageType: pageTypes.SGP,
		title: 'What Does a 10x25 Storage Unit Look Like?',
		description:
			"Imagine a space that's:\n\n- 10 feet wide by 25 feet deep\n\n- About the size of a large one-car garage\n\n- Tall enough to stack items safely and store tall furniture\n\n- Spacious enough to create walkways and organized zones",
	},
	imageSrc: storageUnit10x25,
};

const twoColumnTable2 = {
	image: twoColumnTableImage,
	title: '10x25 Storage Unit Price & Cost Analysis',
	description:
		'The price of a 10x25 storage unit can vary greatly depending on factors such as location, season, and demand fluctuation. Here’s the average monthly cost you can expect in popular locations.',
	type: 'sizeChart',
	slug: 'size-chart-section-10x25-price',
	pageType: pageTypes.SGP,
	tableType: 'specialType',
	headers: [
		{
			label: 'Location Type',
			key: 'comparison',
		},
		{
			label: 'Monthly Cost Range',
			key: 'storageUnit',
		},
	],
	rows: [
		{
			comparison: 'Rural Areas',
			storageUnit: '$120–$180',
		},
		{
			comparison: 'Suburban',
			storageUnit: '$150–$250',
		},
		{
			comparison: 'Urban',
			storageUnit: '$200–$320',
		},
		{
			comparison: 'Major Cities',
			storageUnit: '$250–$400',
		},
	],
};

export const reviews = {
	pageType: pageTypes.SGP,
	title: 'Find the Best 10x25 Storage with SpareFoot',
	reviews: [
		{
			reviewTitle: 'Easy to register and the first month is free',
			reviewRating: 5,
			reviewText:
				"Easy to register and first month was free. The unit is clean and easy to maneuver my classic car in and out. And it's climate-controlled!",
			reviewerInitials: 'CB',
			reviewerName: 'Customer Bill',
			link: 'https://www.trustpilot.com/reviews/676941d937311529e3c8e617',
		},
		{
			reviewTitle: 'Saved me so much time by looking…',
			reviewRating: 5,
			reviewText:
				'This was a fast and easy search to find a storage unit near me with climate control. Very easy to reserve the unit for use as well.',
			reviewerInitials: 'JT',
			reviewerName: 'Judith Talarico',
			link: 'https://www.trustpilot.com/reviews/656df9349864d68ff85a9996',
		},
		{
			reviewTitle: 'Customer service',
			reviewRating: 5,
			reviewText:
				'The SpareFoot customer service representative listened to my needs and found me the absolute perfect place within 5 minutes!',
			reviewerInitials: 'L',
			reviewerName: 'Lee',
			link: 'https://www.trustpilot.com/reviews/681ccbe02c79ce86945f187e',
		},
		{
			reviewTitle: 'Very, very simple to book online',
			reviewRating: 5,
			reviewText:
				'Very, very simple to book online. I called the company right after, and they had my reservation. Will definitely use them again.',
			reviewerInitials: 'DM',
			reviewerName: 'Dara Matthews',
			link: 'https://www.trustpilot.com/reviews/68111eca0f2e258317455576',
		},
	],
};

const faqs = [
	{
		question:
			'How big is a 10x25 storage unit and what can I realistically fit inside?',
		answer:
			'A 10x25 storage unit provides 250 square feet of floor space – roughly the size of a large one-car garage. With standard 8-foot ceilings, you get about 2,000 cubic feet of total storage capacity, which is substantial enough for major storage needs.\n\n' +
			'What can fit in a 10x25 storage unit includes the complete contents of a 3-4 bedroom home: all major furniture pieces, appliances, mattress sets, 50+ boxes, and even outdoor equipment. This size works perfectly for full household moves, business inventory storage, or long-term storage during renovations or relocations.',
	},
	{
		question:
			'What does a 10x25 storage unit look like and how should I organize it?',
		answer: 'For organization, create a center aisle running the length of the unit so you can access both sides. Place large furniture items and appliances along the walls, and use the vertical space efficiently by stacking boxes on top of dressers and sturdy furniture. Keep an inventory list and consider labeling zones for different rooms or categories.',
	},
	{
		question:
			"What's the typical 10x25 storage unit price, and what affects the cost?",
		answer: 'Several factors affect pricing: location is the biggest factor, with urban areas costing significantly more than rural locations. Climate control adds $50-$100 monthly but protects items from temperature and humidity damage. Drive-up access may cost slightly more but provides convenient loading and unloading. Indoor facilities typically charge premium rates but offer better security and weather protection.',
	},
	{
		question: 'Do I need climate control for my 10x25 storage unit?',
		answer: 'Climate control is highly recommended for 10x25 storage units, especially if you are storing complete household contents long-term. While standard units work for short-term storage in moderate climates, climate control becomes important when storing wooden furniture, electronics, important documents, photographs, upholstered items, or anything sensitive to temperature swings and humidity.',
	},
	{
		question: 'Can I store a vehicle in a 10x25 storage unit?',
		answer: "Many 10x25 storage units can accommodate vehicles, motorcycles, boats, or RVs, but you'll need to verify with your specific facility. Some facilities allow vehicle storage in standard units, while others have specific requirements or designated areas for vehicles. A 10x25 storage unit can typically fit a standard car, motorcycle, or small boat with additional space for related equipment and supplies.",
	},
	{
		question: 'How do I maximize space in my large 10x25 storage unit?',
		answer:
			'Maximizing your 10x25 storage unit requires strategic planning to use the generous space efficiently. Start by creating a center aisle from front to back – this gives you access to both sides of the unit. Place the largest items and furniture along the walls, then build out from there.\n\n' +
			'Use vertical space by stacking boxes on top of sturdy furniture like dressers, desks, and appliances. Disassemble large furniture when possible – remove table legs, take apart bed frames, and stand mattresses vertically against walls. Fill hollow items like drawers, appliances, and storage ottomans with smaller belongings. Install temporary shelving units along walls for better organization and easier access to frequently needed items.',
	},
];

const pageType = 'SGP';

export const TenByTwentyFiveContent = {
	pageType: pageTypes.SGP,
	type: '10x25',
	sections: [
		// Hero Section
		{
			title: 'Large 10x25 Storage Units Near You',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					background: 'lighterYellow',
					props: {
						content: {
							pageType,
							title: 'Large 10x25 Storage Units Near You',
							description:
								"Planning a major move, downsizing your home, or need space for a growing business? A 10x25 storage unit offers the room you need for life's bigger transitions. When you need serious storage capacity, a 10x25 storage unit delivers the space and flexibility to keep everything secure and accessible.",
							inputLabel: 'Find Your Ideal 10x25 Storage Unit',
							CTAText: 'Find Your Storage Unit',
							image: sgpHero,
						},
					},
				},
			],
		},

		// Near By Cities
		{
			title: 'nearby units',
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},

		//Alternating Content Block
		{
			title: 'Looking for a Large Storage Unit?',
			modules: [
				{
					type: 'alternatingContent',
					props: {
						props: {
							title: 'Looking for a Large Storage Unit?',
							description:
								"If you're here, chances are that you're looking for a large storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your large storage needs. Here's your Goldilocks storage unit menu to help you find the best storage space:",
							additionalProps: {
								paragraph: {
									color: 'black',
								},
							},
							content: [
								{
									image: altContentImage,
									description:
										'**Large Units:** 10x20, 10x25 (*you are here*), 10x30 \n\n' +
										'**Medium Units:** 10x10, 10x15, 5x15\n\n' +
										'**Small Units:** 5x5, 5x10, Mini storage, Storage lockers',
								},
							],
						},
					},
				},
			],
		},

		//Alternating Content Block
		{
			title: 'Why a 10x25 Storage Unit Is Perfect for Major Storage Needs',
			background: 'gray',
			modules: [
				{
					type: 'alternatingContent',
					props: {
						props: {
							title: 'Why a 10x25 Storage Unit Is Perfect for Major Storage Needs',
							description: '',

							additionalProps: {
								paragraph: {
									color: 'black',
								},
							},
							content: [
								{
									image: efficiency,
									description:
										'### 10x25: The Basics\n\n' +
										"A 10x25 storage unit provides ample space for major life transitions and significant storage requirements. Here's why it's ideal for substantial storage needs:\n\n" +
										'- **Homeowners relocating:** Store entire household contents during moves or renovations\n' +
										'- **Downsizers:** Keep cherished furniture and belongings while transitioning to smaller spaces\n' +
										'- **Business owners:** Maintain inventory, equipment, and supplies cost-effectively\n' +
										'- **Military families:** [Secure storage during deployments or relocations](https://www.sparefoot.com/blog/military-families-pcs-move-tips)\n' +
										'- **Estate management:** Organize and preserve family belongings during transitions',
								},
								{
									image: budget,
									description:
										'### Generous Space, Smart Investment\n\n' +
										'10x25 self-storage units provide excellent value because they:\n\n' +
										'- Accommodate the contents of 3-4 bedroom homes completely\n' +
										'- Offer more cost-effective square footage than renting multiple smaller units\n' +
										'- Provide room to organize and access items without cramming\n' +
										'- Work perfectly for long-term storage during extended transitions',
								},
								{
									image: inventory,
									description:
										'### Versatile Storage for Major Needs\n\n' +
										"A 10 x 25 storage space adapts to your biggest storage challenges, whether you're storing:\n\n" +
										'- Complete household furniture sets\n' +
										'- Major appliances and large equipment\n' +
										'- Business inventory and supplies\n' +
										'- Vehicles, motorcycles, or boats (check facility policies)\n' +
										'- Construction materials and tools',
								},
							],
						},
					},
				},
			],
		},
		//Small Table Block
		{
			title: 'Understanding Your Space: How Big is a 10x25 Storage Unit?',
			modules: [
				{
					type: 'sizeChart',
					id: 'smallTableBlock',
					props: twoColumnTable,
				},
			],
		},

		// Video Image Section
		{
			title: 'Video Image Section',
			background: 'dark',
			modules: [
				{
					type: 'videoSection',
					id: '5x10VideoImageSection',
					props: videoImageSection,
				},
			],
		},

		// Alternating Content Block 1 – Alternate at Subheaders
		{
			title: 'Real-Life Storage Examples',
			background: 'gray',
			modules: [
				{
					type: 'alternatingContent',
					props: {
						props: {
							title: 'Real-Life Storage Examples',
							content: [
								{
									image: houseMove,
									description:
										'### Full House Move:\n\n' +
										'- Complete furniture from 3–4 bedrooms\n' +
										'- Living room and dining room sets\n' +
										'- Major appliances\n' +
										'- 50+ boxes of household items\n' +
										'- [Outdoor furniture and equipment](https://www.sparefoot.com/blog/how-to-store-outdoor-furniture)',
								},
								{
									image: business,
									description:
										'### Business Storage Setup:\n\n' +
										'- Retail inventory and shelving\n' +
										'- Office equipment and furniture\n' +
										'- Marketing materials and displays\n' +
										'- Seasonal merchandise\n' +
										'- Tools and supplies',
								},
								{
									image: homeReno,
									description:
										'### Renovation Storage:\n\n' +
										'- Entire home contents during remodeling\n' +
										'- Furniture protection from dust and damage\n' +
										'- Appliances and fixtures\n' +
										'- Construction materials staging\n' +
										'- Temporary household storage',
								},
							],
						},
					},
				},
			],
		},

		// Alternating Content Block – Maximizing Your 10x25 Storage Space
		{
			title: 'Maximizing Your 10x25 Storage Space',
			modules: [
				{
					type: 'alternatingContent',
					props: {
						props: {
							title: 'Maximizing Your 10x25 Storage Space',
							content: [
								{
									image: organize,
									description:
										'### Strategic Organization Tips:\n\n' +
										'- **Create aisles:** Leave a center pathway for easy access to all areas\n' +
										'- **Zone your space:** Group similar items together in designated areas\n' +
										'- **Use the full height:** Stack safely to 6–7 feet with sturdy items on bottom\n' +
										'- **Install shelving:** Wall-mounted units maximize vertical space',
								},
								{
									image: packing,
									description:
										'### Organization Hacks:\n\n' +
										'- Use furniture as storage (fill dressers and cabinets)\n' +
										'- Disassemble large items to save space\n' +
										'- Create an inventory map showing where items are located\n' +
										'- Keep frequently needed items near the entrance\n' +
										'- Store mattresses and sofas vertically against walls',
								},
							],
						},
					},
				},
			],
		},

		//Small Table Block
		{
			title: '10x25 Storage Unit Price & Cost Analysis',
			background: 'gray',
			modules: [
				{
					type: 'sizeChart',
					id: 'smallTableBlock',
					props: twoColumnTable2,
				},
			],
		},

		// Alternating Content Block – 10x25 Storage Unit Price Factors
		{
			title: '10x25 Storage Unit Price Factors',
			modules: [
				{
					type: 'alternatingContent',
					props: {
						props: {
							title: '10x25 Storage Unit Price Factors',
							content: [
								{
									image: location,
									description:
										'### Location Impact:\n\n' +
										'- Rural areas offer the most affordable options\n' +
										'- Suburban locations balance cost and convenience\n' +
										'- Urban areas cost more but offer better accessibility\n' +
										'- Major cities command premium pricing due to demand',
								},
								{
									image: amenities,
									description:
										'### Facility Features:\n\n' +
										'- **Standard units:** Base pricing\n' +
										'- **Climate-controlled:** Add $50–$100 monthly\n' +
										'- **Indoor access:** Premium of $20–$40\n' +
										'- **Drive-up access:** Convenient for loading, may cost more\n' +
										'- **Enhanced security:** 24/7 monitoring typically included',
								},
								{
									image: calendar,
									description:
										'### Best Times to Rent:\n\n' +
										'- Fall and winter typically offer lower rates\n' +
										'- Avoid peak moving season (May–September)\n' +
										'- Mid-month rentals sometimes get better deals',
								},
							],
							additionalProps: {
								paragraph: {
									color: 'black',
								},
							},
						},
					},
				},
			],
		},

		// Reviews Section
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: reviews,
				},
			],
		},

		//FAQs Section
		{
			title: '10x25 Storage Unit Size FAQs',
			background: 'gray',
			modules: [
				{
					type: 'faqs',
					props: {
						header: '10x25 Storage Unit Size FAQs',
						faqs,
					},
				},
			],
		},

		// Featured Content
		{
			title: 'featured content',
			modules: [
				{
					type: 'featuredContent',
					props: {
						pageType: pageTypes.SGP,
						title: 'Learn More About Storage Unit Size Options',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: storageUnitSize,
								content:
									'How to Pick the Right Size Self Storage Unit',
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: measured,
								content: 'How Are Storage Units Measured?',
								link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
							},
							{
								title: 'Self Storage',
								date: 'October 17, 2025',
								image: largestUnitSize,
								content:
									'5 Ways to Use the Largest Storage Unit Size',
								link: 'https://www.sparefoot.com/blog/largest-storage-unit-size-uses',
							},
							{
								title: 'How to Store It',
								date: 'October 22, 2025',
								image: storageCar,
								content:
									'How to Pick the Right Size Storage Unit for Your Car',
								link: 'https://www.sparefoot.com/blog/car-storage-size-guide',
							},
						],
					},
				},
			],
		},
		{
			title: 'More Ways to Store',
			background: 'gray',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						pageType: pageTypes.SGP,
						cards: ['DriveUp', 'Car', '10x20', '10x30'],
					},
				},
			],
		},
		{
			title: 'nearby units',
			noPaddingBottom: true,
			modules: [
				{
					type: 'storageNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},
	],
};
